<template>
  <v-dialog
    v-model="opened"
    content-class="transactions-history-dialog"
    max-width="600"
    persistent
  >
    <v-tabs-items v-model="tab" mandatory>
      <v-btn class="close-btn" icon @click="opened = false">
        <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
      </v-btn>

      <v-tab-item>
        <div class="transactions-history-dialog__tab-content">
          <h3>{{ $t('investor-report.history') }}</h3>

          <v-select
            v-model="filter"
            class="transactions-history-dialog__types"
            item-text="text"
            dense
            filled
            outlined
            :items="types"
            :label="$t('common.fields.operationType')"
            hide-details
          />

          <v-simple-table height="350">
            <thead>
              <tr>
                <th v-for="(header, key) in headers" :key="key">
                  {{ header.text }}
                </th>
                <th v-if="!noEdit"></th>
              </tr>
            </thead>

            <tbody v-if="transactions.length">
              <tr
                v-for="item in transactions"
                :key="item.id"
                :class="
                  Number(item.amount) > 0
                    ? 'green lighten-5'
                    : 'orange lighten-5'
                "
              >
                <td>{{ item.created_at }}</td>
                <td>{{ item.updated_at }}</td>
                <td class="nowrap">
                  {{ Number(item.amount) }}

                  <v-tooltip v-if="item.comment" color="#464646" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ml-1"
                        color="#464646"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        small
                      >
                        mdi-comment-text-outline
                      </v-icon>
                    </template>

                    {{ item.comment }}
                  </v-tooltip>
                </td>
                <td>{{ getPaymentTypes(item.type) }}</td>
                <td v-if="!noEdit">
                  <v-btn
                    color="primary"
                    small
                    icon
                    @click="
                      () => {
                        editItem = item;
                        tab = 1;
                      }
                    "
                  >
                    <v-icon color="rgba(0, 0, 0, 0.5)">
                      mdi-pencil-circle-outline
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td class="no-data" :colspan="5">
                  {{ $t('common.fields.noData') }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="transactions-history-dialog__tab-content">
          <div class="d-flex align-center mb-4">
            <v-btn
              class="mr-3"
              icon
              @click="
                () => {
                  tab = 0;
                  editItem = null;
                }
              "
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <h3>{{ $t('common.btns.edit') }}</h3>
          </div>

          <transaction-form
            :investor-id="investorId || currentInvestorId"
            :edit-item="editItem"
            :topUp="editItem ? Number(editItem.amount) > 0 : false"
            :opened="tab === 1"
            @updated="proccessResult"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>
import TransactionForm from './TransactionForm.vue';

export default {
  components: { TransactionForm },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    investorId: {
      type: [Number, null],
      default: null,
    },
    noEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tab: 0,
    filter: 0,
    editItem: null,
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.tab = 0;
        this.editItem = null;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    types() {
      return [
        { text: this.$t('investor-report.all-transactions'), value: 0 },
        { text: this.$t('investor-report.pay'), value: 1 },
        { text: this.$t('investor-report.top-up'), value: 2 },
      ];
    },
    headers() {
      return [
        { text: this.$t('dtp.paymentDate') },
        { text: this.$t('common.table.updated') },
        { text: this.$t('common.fields.sum') },
        { text: this.$t('common.fields.paymentMethod') },
      ];
    },
    transactions() {
      switch (this.filter) {
        case 1:
          return this.items.filter(({ amount }) => Number(amount) < 0);
        case 2:
          return this.items.filter(({ amount }) => Number(amount) > 0);
        default:
          return this.items;
      }
    },
    currentInvestorId() {
      return this.$store.state['investor-report'].investorInfo.id;
    },
  },
  methods: {
    getPaymentTypes(id) {
      const types = this.$store.state['investor-report'].paymentTypes;
      return types.find((item) => item.id === id).name;
    },
    proccessResult(result) {
      if (result.success) this.tab = 0;
      this.$emit('updated', result);
    },
  },
};
</script>

<style lang="scss">
.transactions-history-dialog {
  background-color: #fff;

  &__types {
    max-width: 200px;
    margin-top: 20px !important;
    margin-bottom: 5px !important;
  }

  thead {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 10;
  }

  th {
    white-space: nowrap;
  }

  &__tab-content {
    padding: 8px 10px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .no-data {
    color: #464646;
    font-size: 14px;
    text-align: center;
  }
}
</style>
